
import React from 'react';
export default function ReferralExpired() {
  return (
    <div className="text-center p-5">
      <h2>Referral Link Expired</h2>
      <p>This referral link has already been used or is no longer valid.</p>
    </div>
  );
}
